import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { cn } from "../lib/cn.js";
import { Input } from "./input.js";
import { Label } from "./label.js";
/**
 * A labelled field with its error message (already translated by the caller). Works with React Hook Form:
 * `<FormInput label={t("…")} error={message} {...register("name")} />`.
 */
export function FormField({ label, error, hint, htmlFor, className, children, }) {
    return (_jsxs("div", { className: cn("flex flex-col gap-2", className), children: [_jsx(Label, { htmlFor: htmlFor, children: label }), children, hint === undefined || error !== undefined ? null : (_jsx("p", { className: "text-xs text-muted-foreground", children: hint })), error === undefined ? null : (_jsx("p", { id: `${htmlFor}-error`, className: "text-sm text-destructive", children: error }))] }));
}
export function FormInput({ label, error, hint, id, className, ...props }) {
    const generated = useId();
    const inputId = id ?? generated;
    return (_jsx(FormField, { label: label, error: error, hint: hint, htmlFor: inputId, className: className, children: _jsx(Input, { id: inputId, "aria-invalid": error === undefined ? undefined : true, "aria-describedby": error === undefined ? undefined : `${inputId}-error`, ...props }) }));
}
//# sourceMappingURL=form-field.js.map